import { useState } from "react";
import { useLocation } from "react-router-dom";
import "../Styles/RealResults.css";
import { useLang } from "../i18n/useLang";

function RealResults() {
  const [hovered, setHovered] = useState(null);
  const location = useLocation();
  const { t } = useLang();

  const items = t.home.results.items;
  const caseItems = t.home.results.caseItems;

  return (
    <div className="rr" aria-label="Results section">
      <div className="RRTop">
        <div className="leftRR">
          <h2>
            {t.home.results.titleLine1} <br /> {t.home.results.titleLine2}
          </h2>
        </div>

        <div className="rightRR">
          <p>
            {t.home.results.subtitleLine1} <br /> {t.home.results.subtitleLine2}
          </p>

          <a className="ViewMoreBtn" href="#contact">
            {t.home.results.cta}
          </a>
        </div>
      </div>

      {/* Default grid */}
      <div className="ImgsCont">
        <div className="row">
          {items.slice(0, 2).map((img) => (
            <div
              key={img.id}
              className={`imgBox ${hovered === img.id ? "active" : ""}`}
              onMouseEnter={() => setHovered(img.id)}
              onMouseLeave={() => setHovered(null)}
            >
              <img
                src={img.imgURL}
                srcSet={img.imgSrcSet}
                sizes="(max-width: 900px) calc(100vw - 40px), 550px"
                alt={img.title}
                width="1024"
                height="682"
                loading="lazy"
                decoding="async"
              />
              <div className="overlay">
                <h3>{img.title}</h3>
                <p>{img.text}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="row">
          {items.slice(2, 4).map((img) => (
            <div
              key={img.id}
              className={`imgBox ${hovered === img.id ? "active" : ""}`}
              onMouseEnter={() => setHovered(img.id)}
              onMouseLeave={() => setHovered(null)}
            >
              <img
                src={img.imgURL}
                srcSet={img.imgSrcSet}
                sizes="(max-width: 900px) calc(100vw - 40px), 550px"
                alt={img.title}
                width="1024"
                height="683"
                loading="lazy"
                decoding="async"
              />
              <div className="overlay">
                <h3>{img.title}</h3>
                <p>{img.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Extra Case items ONLY on /case */}
      {location.pathname === "/case" && (
        <div className="ImgsCont case">
          <div className="row single">
            {caseItems
              .filter((img) => img.layout === "full")
              .map((img) => (
                <div
                  key={img.id}
                  className={`imgBox full ${hovered === img.id ? "active" : ""}`}
                  onMouseEnter={() => setHovered(img.id)}
                  onMouseLeave={() => setHovered(null)}
                >
                  <img src={img.imgURL} alt={img.title} loading="lazy" decoding="async" />
                  <div className="overlay">
                    <h3>{img.title}</h3>
                    <p>{img.text}</p>
                  </div>
                </div>
              ))}
          </div>

          <div className="row">
            {caseItems
              .filter((img) => img.layout === "half")
              .map((img) => (
                <div
                  key={img.id}
                  className={`imgBox ${hovered === img.id ? "active" : ""}`}
                  onMouseEnter={() => setHovered(img.id)}
                  onMouseLeave={() => setHovered(null)}
                >
                  <img src={img.imgURL} alt={img.title} loading="lazy" decoding="async" />
                  <div className="overlay">
                    <h3>{img.title}</h3>
                    <p>{img.text}</p>
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default RealResults;
